@if (publication(); as post) {
  <pai-publication-item-card [data]="post" />
}
